<header class="Header">
	<h1 class="Heading">
		<span class="Heading-text">Summit</span>
		<span class="Heading-logo" />
		<span class="Heading-text">Branding</span>
	</h1>
	<div class="Header-image" />
	<div class="Tagline">Software at a higher level</div>
</header>

<style>
	.Tagline {
		display: flex;
		font: bold 20px aviano, serif;
		justify-content: center;
		padding: 25px 0;
	}
	.Header {
		background-color: #000;
		color: #fff;
		font-family: aviano, serif;
		width: 100%;
	}
	.Header-image {
		background-image: url('/images/mountains-bg.png');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 100px;
		margin: 0 auto;
		width: 100%;
		max-width: 390px;
	}
	.Heading {
		align-items: center;
		display: flex;
		justify-content: center;
		padding: 10px 0;
	}
	.Heading-text {
		font-size: 20px;
		font-weight: normal;
	}
	.Heading-logo {
		background-image: url('/images/summitBrandingLogo-whiteOnClear.png');
		background-size: contain;
		margin: 0 25px;
		height: 50px;
		width: 50px;
	}
	@media only screen and (min-width: 768px) {
		.Heading-text {
			font-size: 30px;
		}
		.Tagline {
			font-size: 30px;
		}
		.Header-image {
			max-width: 600px;
			height: 120px;
		}
	}
	@media only screen and (min-width: 1200px) {
		.Header {
			overflow: hidden;
		}
		.Header-image {
			max-width: 1100px;
			height: 130px;
		}
		.Heading {
			padding: 20px 0 30px;
		}
		.Heading-text {
			font-size: 36px;
		}
		.Tagline {
			padding: 20px 0;
			font-size: 36px;
		}
	}
</style>